import { z } from 'zod'

/**
 * 
 * "amendmentDetails": {
   "canAmend": false,
   "reason": "<PLAN_AMENDMENT_FAILURE_REASON>",
   "canAmendFrom": "yyyy-MM-ddTHH:mm:SS.sssZ"
   "newPlanId": "uuid" // when reason is 'plan.amendment.upgrade_in_progress' or 'plan.amendment.downgrade_in_progress'
 }

 * Enum PLAN_AMENDMENT_FAILURE_REASON:
 * plan.amendment.too_close_to_plan_start
 * plan.amendment.too_close_to_next_bill
 * plan.amendment.too_far_in_future
 * plan.amendment.upgrade_in_progress
 * plan.amendment.downgrade_in_progress
 * plan.amendment.plan_is_inactive
 * plan.amendment.plan_is_ceased
 * plan.amendment.plan_is_paused
 * 
 */

const AmendmentReasonsWithNewPlanEnum = z.enum([
  'plan.amendment.upgrade_in_progress',
  'plan.amendment.downgrade_in_progress',
])

const AmendmentReasonsWithoutNewPlanEnum = z.enum([
  'plan.amendment.too_close_to_plan_start',
  'plan.amendment.too_close_to_next_bill',
  'plan.amendment.too_far_in_future',
  'plan.amendment.plan_is_inactive',
  'plan.amendment.plan_is_ceased',
  'plan.amendment.plan_is_paused',
])

const BaseCannotAmend = { canAmend: z.literal(false), reason: z.string(), canAmendFrom: z.string().datetime() }
const CannotAmend = z.discriminatedUnion('reason', [
  z.object({
    ...BaseCannotAmend,
    reason: AmendmentReasonsWithNewPlanEnum,
    newPlanId: z.string().uuid(),
  }),
  z.object({ ...BaseCannotAmend, reason: AmendmentReasonsWithoutNewPlanEnum }),
])

const CanAmend = z.object({ canAmend: z.literal(true), reason: z.undefined(), canAmendFrom: z.undefined() })

export const amendmentReasonsWithNewPlan = AmendmentReasonsWithNewPlanEnum.options
export const amendmentReasonsWithoutNewPlan = AmendmentReasonsWithoutNewPlanEnum.options
export const amendmentReasons = [...amendmentReasonsWithNewPlan, ...amendmentReasonsWithoutNewPlan]

export const planAmendmentDetailsSchema = z.union([CanAmend, ...CannotAmend.options])
